"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "clean", {
    enumerable: true,
    get: function() {
        return clean;
    }
});
const _lodashidentity = /*#__PURE__*/ _interop_require_default(require("lodash.identity"));
const _lodashpickby = /*#__PURE__*/ _interop_require_default(require("lodash.pickby"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function clean(object) {
    return (0, _lodashpickby.default)({
        ...object
    }, function pickParams(param) {
        if (typeof param === 'string') {
            return param.trim();
        }
        if (typeof param === 'object') {
            return Object.keys(clean(param)).length > 0;
        }
        if (typeof param === 'number') {
            return true;
        }
        if (typeof param === 'boolean') {
            return true;
        }
        return (0, _lodashidentity.default)(param);
    });
}

//# sourceMappingURL=clean.js.map